/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Confirmndasignedmodaldescription5Inputs */

const en_coinvestments_tracking_confirmndasignedmodaldescription5 = /** @type {(inputs: Coinvestments_Tracking_Confirmndasignedmodaldescription5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm NDA has been signed on behalf of the organisation`)
};

/**
* | output |
* | --- |
* | "Confirm NDA has been signed on behalf of the organisation" |
*
* @param {Coinvestments_Tracking_Confirmndasignedmodaldescription5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_confirmndasignedmodaldescription5 = /** @type {((inputs?: Coinvestments_Tracking_Confirmndasignedmodaldescription5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Confirmndasignedmodaldescription5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_confirmndasignedmodaldescription5(inputs)
});
export { coinvestments_tracking_confirmndasignedmodaldescription5 as "coInvestments_tracking_confirmNdaSignedModalDescription" }